import { useAuth } from '../context/AuthContext';

// Colores por defecto (paleta Imagina)
const DEFAULT_COLORS = {
  primario: '#C9A85C',
  secundario: '#C5B8A2',
  terciario: '#5A7A7A',
  cuaternario: '#5A7A7A',
  fondo: '#FFFFFF',
  superficie: '#F5F5F5',
  fondo_cabecera: '#333333',
  texto: '#333333',
  texto_secundario: '#666666',
  error: '#DC3545'
};

// Hook para obtener los colores del tema actual
export const useThemeColors = () => {
  const { empresa } = useAuth();
  
  const empresaColors = empresa?.colores_tema || {};
  
  // Mergear con defaults y soportar formato antiguo
  const colors = {
    primario: empresaColors.primario || DEFAULT_COLORS.primario,
    secundario: empresaColors.secundario || DEFAULT_COLORS.secundario,
    terciario: empresaColors.terciario || empresaColors.acento || DEFAULT_COLORS.terciario,
    cuaternario: empresaColors.cuaternario || DEFAULT_COLORS.cuaternario,
    fondo: empresaColors.fondo || DEFAULT_COLORS.fondo,
    superficie: empresaColors.superficie || DEFAULT_COLORS.superficie,
    fondo_cabecera: empresaColors.fondo_cabecera || DEFAULT_COLORS.fondo_cabecera,
    texto: empresaColors.texto || DEFAULT_COLORS.texto,
    texto_secundario: empresaColors.texto_secundario || DEFAULT_COLORS.texto_secundario,
    error: empresaColors.error || DEFAULT_COLORS.error,
    // Alias para compatibilidad
    acento: empresaColors.terciario || empresaColors.acento || DEFAULT_COLORS.terciario
  };
  
  return colors;
};

// Función para oscurecer un color hex
const darkenColor = (hex, percent = 15) => {
  if (!hex || typeof hex !== 'string') return '#000000';
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.max(0, (num >> 16) - amt);
  const G = Math.max(0, ((num >> 8) & 0x00FF) - amt);
  const B = Math.max(0, (num & 0x0000FF) - amt);
  return `#${(0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)}`;
};

// Función para aclarar un color hex
const lightenColor = (hex, percent = 15) => {
  if (!hex || typeof hex !== 'string') return '#FFFFFF';
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.min(255, (num >> 16) + amt);
  const G = Math.min(255, ((num >> 8) & 0x00FF) + amt);
  const B = Math.min(255, (num & 0x0000FF) + amt);
  return `#${(0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)}`;
};

// Estilos para botón primario (dorado) con hover usando secundario
export const getPrimaryButtonStyles = (colors) => ({
  style: { backgroundColor: colors.primario },
  onMouseEnter: (e) => { e.currentTarget.style.backgroundColor = colors.secundario; },
  onMouseLeave: (e) => { e.currentTarget.style.backgroundColor = colors.primario; },
});

// Estilos para botón terciario (teal) con hover oscurecido
export const getTertiaryButtonStyles = (colors) => ({
  style: { backgroundColor: colors.terciario },
  onMouseEnter: (e) => { e.currentTarget.style.backgroundColor = darkenColor(colors.terciario); },
  onMouseLeave: (e) => { e.currentTarget.style.backgroundColor = colors.terciario; },
});

// Estilos para botón de error con hover oscurecido
export const getErrorButtonStyles = (colors) => ({
  style: { backgroundColor: colors.error },
  onMouseEnter: (e) => { e.currentTarget.style.backgroundColor = darkenColor(colors.error); },
  onMouseLeave: (e) => { e.currentTarget.style.backgroundColor = colors.error; },
});

// Alias para compatibilidad con código antiguo
export const getAccentButtonStyles = getTertiaryButtonStyles;

export default useThemeColors;
